<template>
  <div class="category__list" v-show="products.length">
    <h3>Anderen kochten ook</h3>
    <div class="catalog__category-list slider__container" :class="{_active : products.length < 5}">
      <swiper ref="upsellSlider" :options="slideOptions">
        <swiper-slide v-for="product in products" :key="product.product_id">
          <product-list-item :data-source="'dataSource'" :product="product" type="upsell">
          </product-list-item>
        </swiper-slide>
      </swiper>
      <div class="slider__controls upsellSlider">
        <div class="slider__control prev" slot="button-prev"></div>
        <div class="slider__control next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';
  import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';
  import {apiClient} from '../../../shared/services/api-client';
  import {enhancedEcommerce} from '../../../shared/helpers/enhanced-ecommerce';
  import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

  @Component({
    name: 'catalog-product-upsell',
    components: {
      'product-list-item': ServiceContainer().getComponent('catalog-product-list-item'),
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    }
  })

  export default class extends Vue {
    @Prop({default: null}) readonly productId!: null | number;
    @Prop({default: 12}) readonly limit!: number;

    private products: Array<object> = [];
    private isLoading: boolean = false;

    private slideOptions: object = {
      slidesPerView: 2,
      spaceBetween: 12,
      navigation: {
        nextEl: `.upsellSlider .next`,
        prevEl: `.upsellSlider .prev`
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 5
        }
      }
    };

    async created(): Promise<any> {
      this.products = await this.fetchProducts();
      enhancedEcommerce.addProductImpressions(this.products);
      SolarDataLayer.init().addViewItemsList(this.products, 'Product upsell');
    };

    private get fetchProductRequestParams(): object {
      return {
        limit: this.limit
      };
    };

    private async fetchProducts(): Promise<any> {
      this.isLoading = true;

      const productId = this.productId || this.$store.state.CatalogProduct.productData.product_id;

      try {
        const {data} = await apiClient.get(`/api/catalog/product/${productId}/up-sell/list`, {
          params: this.fetchProductRequestParams
        });

        return data;
      } catch (e) {
        return [];
      } finally {
        this.isLoading = false;
      }
    };

    private updated(): void {
      this.$nextTick(() => {
        ('.catalog__category-list a h2').matchHeight(true);
        const resizeEvent = new UIEvent('resize');
        window.dispatchEvent(resizeEvent);
      });
    }
  }
</script>
